import React from "react";
import { Popup } from "react-map-gl/maplibre";
import { Box } from "@mui/material";

// Shared chrome for the MapLibre popups anchored to a map location, so the
// entity popup and the vector feature info popup stay visually identical.

interface Props {
  /** Remounts the MapLibre popup when the subject changes — without it the popup can appear frozen. */
  popupKey: string;
  coordinates: [number, number];
  onClose: () => void;
  children: React.ReactNode;
}

const MapPopupShell: React.FC<Props> = ({ popupKey, coordinates, onClose, children }) => (
  <Popup
    key={popupKey}
    longitude={coordinates[0]}
    latitude={coordinates[1]}
    offset={[0, -16]}
    anchor='bottom' // Force the anchor to always be at the bottom
    closeOnClick={false}
    maxWidth='500px'
    onClose={onClose}
    className='react-popup'
    subpixelPositioning
  >
    <Box
      sx={{
        maxWidth: 480,
        minWidth: 200,
        maxHeight: "80vh",
        overflowY: "auto",
        "& .MuiCard-root": {
          borderRadius: "8px"
        }
      }}
    >
      {children}
    </Box>
  </Popup>
);

export default MapPopupShell;
